import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const SESSION_FLAG_KEY = "loginEventLogged";

/**
 * Loggt pro Browser-Session genau einmal pro User ein login_event.
 * Fire-and-forget: Fehler werden geloggt, aber niemals geworfen,
 * damit der Auth-Flow nicht blockiert wird.
 */
export function useLoginTracking() {
  useEffect(() => {
    const logIfNeeded = async (userId: string | undefined | null) => {
      if (!userId) return;
      if (sessionStorage.getItem(SESSION_FLAG_KEY) === userId) return;
      try {
        const { error } = await supabase
          .from("login_events")
          .insert({ user_id: userId });
        if (error) {
          console.warn("login_events insert failed:", error.message);
          return;
        }
        sessionStorage.setItem(SESSION_FLAG_KEY, userId);
      } catch (e) {
        console.warn("login_events insert exception:", e);
      }
    };

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      // SIGNED_IN: frischer User-Login.
      // INITIAL_SESSION (mit session): App-Reload, User war bereits eingeloggt.
      if (event === "SIGNED_IN" || (event === "INITIAL_SESSION" && session)) {
        logIfNeeded(session?.user?.id);
      }
      if (event === "SIGNED_OUT") {
        sessionStorage.removeItem(SESSION_FLAG_KEY);
      }
    });

    return () => subscription.unsubscribe();
  }, []);
}
